import { Box, Button, Divider, FormControl, Modal, TextField, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { ChangeEvent } from 'react';

interface ModalProps {
  onClose: (event: any, reason: 'backdropClick' | 'escapeKeyDown') => void;
  open: boolean;
  onSubmit: (evt: { preventDefault: () => void }) => Promise<void> | void;
  fieldValue: string;
  onInputChange: (event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  isErrorCode?: boolean;
  errorDesc: string;
  modalDescription?: string;
  modalTitle?: string;
}

const TwoFactorAuthenticationModal = ({
  onClose,
  open,
  onSubmit,
  fieldValue,
  onInputChange,
  isErrorCode,
  errorDesc,
  modalDescription,
  modalTitle,
}: ModalProps) => {
  const useStyles = makeStyles({
    input: {
      '& input[type=number]': {
        '-moz-appearance': 'textfield',
      },
      '& input[type=number]::-webkit-outer-spin-button': {
        '-webkit-appearance': 'none',
        margin: 0,
      },
      '& input[type=number]::-webkit-inner-spin-button': {
        '-webkit-appearance': 'none',
        margin: 0,
      },
    },
  });

  const classes = useStyles();

  return (
    <Modal
      data-testid="two-factor-auth-model"
      onClose={onClose}
      open={open}
      style={{ alignContent: 'center', justifyContent: 'center', display: 'flex', flexWrap: 'wrap' }}
    >
      <Box display="flex" bgcolor="white" borderRadius="10px" flexDirection="column" p={8}>
        <Typography variant="h3" textAlign={'center'}>
          {modalTitle}
        </Typography>
        <Divider sx={{ my: '8px' }} />
        <Box display="flex" flexDirection="column" gap={2} py={4}>
          <Typography textAlign={'center'}>{modalDescription}</Typography>
          <FormControl onSubmit={onSubmit}>
            <TextField
              name="2fa-code"
              inputProps={{ 'data-testid': '2fa-input' }}
              label="Verification Code"
              placeholder="Enter code to proceed"
              value={fieldValue}
              onChange={onInputChange}
              className={classes.input}
              type="number"
              autoComplete="off"
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  onSubmit(e);
                }
              }}
            />
          </FormControl>
          <Button data-testid="2fa-submit-btn" variant="contained" type="submit" size="large" onClick={onSubmit}>
            Verify
          </Button>
          {isErrorCode && (
            <Typography variant="body2" color="red" textAlign="center">
              {errorDesc ?? 'Error'}
            </Typography>
          )}
        </Box>
      </Box>
    </Modal>
  );
};

export { TwoFactorAuthenticationModal };
